import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { ShutterStockFilter } from './shutter-stock/shutter-stock-filter';

export const StockImageFilter = (props) => {
  const {
    i18nLegacy,
    onFilterQueryChange,
    popoverContainer,
  } = props;

  const [data, setData] = useState({});
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const [filterQuery, setFilterQuery] = useState({});

  useEffect(() => {
    if (data.predicates) {
      const keyValueQueryPairs = _.reduce(
        data.predicates,
        (memo, predicate) => {
          // there is only one key per predicate
          const [key] = _.keys(predicate);
          const addedKeyValue = {};
          const [valuesArray] = _.values(_.values(predicate)[0]);

          // As we support multi-selection, we format the array in the following way
          // key[0]=value, key[1]=value
          /* istanbul ignore next */
          if (valuesArray.length > 1) {
            valuesArray.forEach((value, index) => {
              addedKeyValue[`${key}[${index}]`] = value;
            });
          } else {
            [addedKeyValue[key]] = valuesArray;
          }

          return _.extend(memo, addedKeyValue);
        }, {}
      );

      setFilterQuery(keyValueQueryPairs);

      /* istanbul ignore else */
      onFilterQueryChange(keyValueQueryPairs);
    }
  }, [data, onFilterQueryChange]);

  return (
    <ShutterStockFilter
      i18nLegacy={i18nLegacy}
      data={data}
      setData={setData}
      popoverContainer={popoverContainer}
    />
  );
};

StockImageFilter.propTypes = {
  onFilterQueryChange: PropTypes.func.isRequired,
  i18nLegacy: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  popoverContainer: PropTypes.shape(),
};

StockImageFilter.defaultProps = {
  popoverContainer: null,
};
